import React, { Component } from 'react'
import styles from './Experience.module.scss'
import { Parallax } from 'react-scroll-parallax'

class Experience extends Component {
  render() {
    return (
      <div className={styles.experiencePage}>
        <div className={styles.content}>
          <div className={styles.first}>
            <div className={styles.left}>
              <h1>Experience</h1>
            </div>
            <div className={styles.line2} />

            <div className={styles.right}>
              <h2 className={styles.country}>
                <b>SINGAPORE</b>
              </h2>

              <h2>
                <b>Ubisoft Singapore</b> | UI Technical Artist
              </h2>

              <h2>2023 - Present</h2>

              <h2>
                Building player-facing UI systems for shipped AAA games,
                combining technical implementation with close collaboration
                across art, design and engineering.
              </h2>
              <h2>
                <a
                  href="https://www.ubisoft.com/en-gb/game/skull-and-bones"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Skull and Bones
                </a>
              </h2>

              <h2>
                <b>Web Developer</b>
              </h2>

              <h2>
                Developed internal tools and UI solutions to support production
                workflows, player data access and game development teams.
              </h2>

              <h2>
                <b>UI Technical Artist</b>
              </h2>

              <h2>
                Transitioned into UI Technical Art, contributing to
                player-facing UI implementation, asset integration and technical
                support within the game engine.
              </h2>

              <h2>
                <a
                  href="https://www.ubisoft.com/en-gb/game/the-division/resurgence"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Tom Clancy's The Division Resurgence
                </a>
              </h2>

              <h2>
                <b>UI Technical Artist & C++ Developer</b>
              </h2>

              <h2>
                Implementing and refining player-facing UI features, working un
                unreal and C++ to support UI systems and gameplay features.
                Pre-launch bug fixing and post-launch support for live game
                development.
              </h2>

              <h2>
                Contributing to UI systems, Lua scripting, accessibility
                features and technical investigations across live game
                development.
              </h2>
            </div>

            <div className={styles.right}>
              <h2 className={styles.country}>
                <b>HONG KONG</b>
              </h2>
              <h2>
                <b>KintoHub</b> Front End Engineer
              </h2>
              <h2>September 2017 - May 2020 </h2>
              <h2>HTML / JSX / JS / SCSS </h2>
              <h2>
                React / Node.js / API communication / GraphQL Microservices
              </h2>
              <h2>Unit testing</h2>
              <h2 className={styles.country}>
                <b>LONDON</b>
              </h2>
              <h2>
                <b>Fuse Universal</b> Front End Web Developer
              </h2>
              <h2>May 2016 - November 2016 (7 months)</h2>
              <h2>
                HTML / CSS / SASS / Coffeescript in a Ruby, Backbone &
                Marionette stack.
              </h2>
              <h2>Unit testing</h2>

              <h2>
                <b>Durable Digital</b> Front End Developer
              </h2>
              <h2>March 2015 - May 2016</h2>
              <h2>(1 year 3 months) London Front end engineering</h2>
              <h2>
                HTML / CSS / LESS / JavaScript / Angular and C#, in Sitecore and
                Umbraco.
              </h2>
            </div>
          </div>
          <div className={styles.second}>
            <div className={styles.left}>
              <h1>Education</h1>
            </div>
            <div className={styles.line} />
            <div className={styles.right}>
              <h2>
                <b>.NET Object Oriented Programming</b> using C# 2015 City
                University, London
              </h2>
              <h2>
                <b>Web Development</b> Immersive Course 2014 General Assembly,
                London
              </h2>
              <h2>
                <b>Front End</b> Web Development Course 2014 General Assembly,
                London
              </h2>
              <h2>
                Level 4 (Upper Intermediate) Intensive <b>Korean</b> Course 2010
                - 2011 Konkuk University, Seoul
              </h2>
              <h2>
                MSc. <b>Medical Parasitology</b> 2005 - 2006 London School of
                Hygiene and Tropical Medicine, London
              </h2>
              <h2>
                BSc. (Honours) <b>Environmental Science</b> 2001 - 2005 Kings
                College London, University of London, London
              </h2>

              <img
                className={styles.arrows}
                src="/images/arrows_down_singular.png"
                alt=""
              />

              <Parallax
                className={styles.triangle}
                x={[30, -30]}
                y={[70, -70]}
                slowerScrollRate={true}
              >
                <img src="/images/triangle.svg" alt="triangle" />
              </Parallax>
              <Parallax
                className={styles.triangle2}
                x={[30, -30]}
                y={[70, -70]}
                slowerScrollRate={true}
              >
                <img src="/images/triangle.svg" alt="triangle" />
              </Parallax>
              <Parallax
                className={styles.triangle3}
                x={[30, -30]}
                y={[70, -70]}
                slowerScrollRate={true}
              >
                <img src="/images/triangle.svg" alt="triangle" />
              </Parallax>
            </div>
          </div>

          <div className={styles.third}>
            <div className={styles.left}>
              <h1>Skills</h1>
            </div>

            <div className={styles.line3} />

            <div className={styles.right}>
              <h2>
                <b>Game Development</b> My current focus is UI Technical Art for
                AAA game development, implementing player-facing UI systems and
                features while collaborating closely with artists, designers and
                engineers. I have experience working with Unreal Engine, Anvil,
                Lua and accessibility features across shipped titles.
              </h2>

              <h2>
                <b>Software Engineering</b> With over nine years of professional
                software engineering experience, I have worked across modern web
                technologies including JavaScript, TypeScript, React, Node.js
                and REST APIs. My engineering background continues to influence
                how I approach technical art, problem solving and collaboration.
              </h2>

              <h2>
                <b>Technical Art</b> I enjoy working where programming and
                creativity meet, bringing UI designs to life through
                implementation, technical problem solving and close
                collaboration with multidisciplinary teams. Outside of work I'm
                continuing to expand my knowledge of technical art through
                character sculpting in ZBrush and exploring the wider 3D
                character creation pipeline.
              </h2>

              <h2>
                <b>Continuous Learning</b> One of the things I enjoy most about
                working in games is that there is always something new to learn.
                I'm currently developing my C++ knowledge, exploring AI-assisted
                development workflows and continually looking for opportunities
                to broaden my technical and creative skillset.
              </h2>
            </div>
          </div>

          <div className={styles.fourth}>
            <div className={styles.left}>
              <h1>
                Outside <i>of</i> Work
              </h1>
            </div>

            <div className={styles.line4} />

            <div className={styles.right}>
              <h2>Everything from Soulslikes to obscure FMV games</h2>
              <h2>Harp</h2>
              <h2>Muay Thai & Boxing</h2>
              <h2>Cycling</h2>
              <h2>Painting</h2>
              <h2>Character Sculpting (ZBrush)</h2>
              <h2>Handmade Dice Making</h2>
              <h2>Crochet</h2>
            </div>

            <div className={styles.hobbiesBackground}>
              <img
                src="/images/about_me_hobbies_background.svg"
                alt="monstera gloves and ps5 controller"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Experience
